export const RolesConstants = {
  ASM: "ASM",
  AGENT: "Agent",
  FOS: "FOS",
  CONSUMER: "Consumer",
  RETAILER: "Retailer",
  SUPER_USER: "Super user",
  OPERATIONS: "Operations"
};
